const userAccess = {
  blockListUpload: ['developer', 'driverOps'],
  mustRequest: ['developer', 'driverOps'],
};

const groupAccess = {};

export { userAccess, groupAccess };
